import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PartnerForm from '../components/PartnerForm';
import { useMutatePartnerHandler } from '../dataHandlers/mutatePartnerHandler';

export default function PartnerCreatePage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { onSubmit, error, isPending } = useMutatePartnerHandler({
    onSuccess: () => navigate('/partners'),
  });

  useEffect(() => {
    if (!isPending && isSubmitting) setIsSubmitting(false);
  }, [isPending, isSubmitting]);

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <PartnerForm
        onSubmit={(payload) => onSubmit(payload, false)}
        onCancel={() => navigate('/partners')}
        initialData={{ id: '', name: '', email: '', is_embedded: false }}
        apiErrors={error}
        isLoading={isPending || isSubmitting}
      />
    </Stack>
  );
}
